<template>
  <div class="outterBox">
    <div class="container">
      <h2>NEWS ROOM</h2>
      <div>
        <SlideCarousels
          ref="slides"
          :items="items"
          :item-total-count="items.length"
          :breakpoints="breakpoints"
          :slide-number="1"
          :fixed-height="fixedHeight"
          :arrows="true"
          :fade="true"
        >
          <template v-slot:slides>
            <VueperSlide v-for="item in items" :key="item.id">
              <template #content>
                <div ref="top">
                  <NewsroomItem :item="item" />
                </div>
              </template>
            </VueperSlide>
          </template>
        </SlideCarousels>
      </div>
    </div>
  </div>
</template>

<script>
import SlideCarousels from '@/components/SlideCarousels';
import {VueperSlide} from 'vueperslides';
import NewsroomItem from '@/pages/MainPage/Components/NewsroomItem';
import boardService from '@/services/board.service';
import {BOARD_ID} from '@/util/BoardConst';
import moment from 'moment';

export default {
  name: 'Newsroom',
  data() {
    return {
      windowWidth: 0,
      fixedHeight: '620px',
      items: [],
      breakpoints: {
        992: {
          bullets: false,
          arrows: false,
          visibleSlides: 1,
          touchable: true,
          disableArrowsOnEdges: true,
        },
      },
    };
  },

  async created() {
    // {
    //   id: 0,
    //   title: '국내 최고 골프장에 선정된 핀크스 골프클럽',
    //   date: '2021-12-31',
    //   image: 'main_newsroom_sample01.jpg',
    // },

    const aList = await boardService.getArticleList(
      BOARD_ID.BID_PODO_NEWSROOM,
      1,
      10,
      'BoardArticleDetailWithFilesWithoutBase64',
    );

    console.log(aList);

    this.items = aList._embedded.boardArticles.map(x => ({
      id: x.id,
      title: x.title,
      date: moment(x.startDate).format('YYYY-MM-DD'),
      image: `${x.attachFiles[0]?.urlPath}${x.attachFiles[0]?.fileName}`,
      subtitle: x.subtitle1,
    }));

    this.$nextTick(() => {
      this.refreshHeight();
    });
  },
  watch: {
    windowWidth(newHeight, oldHeight) {
      this.refreshHeight();
    },
  },
  mounted() {
    this.$nextTick(() => {
      window.addEventListener('resize', this.onResize);
      this.refreshHeight();
    });
  },
  beforeDestroy() {
    window.removeEventListener('resize', this.onResize);
  },

  methods: {
    onResize() {
      this.windowWidth = window.innerWidth;
    },
    refreshHeight() {
      console.log('HEIGHT>>>', this.$refs.top);
      if (this.$refs.top !== undefined) {
        let px = this.$refs.top[0].clientHeight;
        this.fixedHeight = `${px + 20}px`;
        console.log('HEIGHT>>>', this.fixedHeight);
      }
    },
  },
  components: {SlideCarousels, VueperSlide, NewsroomItem},
};
</script>

<style scoped lang="scss">
h2 {
  padding-top: 3rem;
  padding-bottom: 3rem;
  height: 8rem;
  text-align: center;
  color: #222222;
  font-family: 'Jeju Myeongjo', sans-serif;
  font-weight: 700;
}

.navDiv {
  position: absolute;
  bottom: 0px;
  z-index: 120;
}

.outterBox {
  border-top: 1px solid #eaeaea;
}
</style>
